import * as React from 'react';

import styles from './stages-empty.module.css';

type Props = {
    titleText: string;
    bodyText: string;
};

/*
 * Note: This component used to push to a stages onboarding modal,
 * but that's been sunsetted.
 */
export function StagesEmpty(props: Props) {
    return (
        <div className={styles.container}>
            <img src='/include/images/stages/stage-chevrons_2x.png' className={styles.img} />
            <div className={styles.title}>{props.titleText}</div>
            <div className={styles.body}>{props.bodyText}</div>
        </div>
    );
}
